import { Box, Checkbox, Flex, Text, Textarea } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { useAreaComum, useFindAreaComum } from "core/features/area-comum/hooks";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import colors from "core/resources/theme/colors";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Field from "ui/components/Input/Field";
import SelectTipoAreaComum from "ui/components/Input/SelectTipoAreaComum";
import { CloseModalButton } from "components/Button/CloseModalButton";
import history from "infra/helpers/history";
import { useLoading } from "ui/components/GlobalLoading";

function DadosCadastrais({
  onSaved,
  id,
}: {
  onSaved: (id: string) => void;
  id: string;
}) {
  const { tenant } = useCurrentTenant();

  const { isLoading, mutate: handleSave } = useAreaComum(tenant.id);

  const { data: defaultData, isLoading: isLoadingAreaComum } = useFindAreaComum(
    tenant.id,
    id
  );

  const _handleSave = (values: any) => {
    handleSave(
      { id, ...values },
      {
        onError: (err) => {
          showErrorAxios(err);
        },
        onSuccess: ({ data }) => {
          showSuccess();
          onSaved(data.id);
        },
      }
    );
  };

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      confirmacaoAutomatica: true,
    },
  });

  useEffect(() => {
    reset(defaultData);
  }, [defaultData, reset]);

  useLoading(isLoading);

  return (
    <>
      <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
        Dados cadastrais
      </Text>

      <Box mb="16px">
        <Row gutter={32}>
          <Col sm={8}>
            <Field
              control={control}
              label="Tipo da área comum"
              name="tipoAreaComumId"
              rules={{ required: "Campo obrigatório" }}
              render={({ field, isInvalid }) => (
                <SelectTipoAreaComum {...field} isInvalid={isInvalid} />
              )}
            />
          </Col>

          <Col sm={8}>
            <Field label="Nome" control={control} name="nome" />
          </Col>

          <Col sm={8}>
            <Field
              label="Capacidade máxima"
              control={control}
              name="capacidadeMaxima"
              inputProps={{
                type: "number",
              }}
              rules={{ required: "Campo obrigatório" }}
            />
          </Col>
        </Row>
      </Box>

      <Box mb="16px">
        <Row gutter={32}>
          <Box as={Col} sm={12}>
            <Field
              control={control}
              name="confirmacaoAutomatica"
              render={({ field }) => (
                <Checkbox
                  isChecked={!!field.value}
                  onChange={() => field.onChange(!field.value)}
                >
                  Confirmação automática
                </Checkbox>
              )}
            />
          </Box>
        </Row>
      </Box>

      <Box mt="48px">
        <Flex>
          <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
            Termo de uso
          </Text>
          <Text pl="8px" pt="6px" color={colors.primary}>
            (Que tal deixar as informações mais importantes no começo?)
          </Text>
        </Flex>
        <Field
          control={control}
          name="termoUso"
          render={({ field, isInvalid }) => (
            <Textarea
              isInvalid={isInvalid}
              className="chakra-input"
              rows={6}
              {...field}
            />
          )}
        />
      </Box>

      <Flex justifyContent={"flex-end"} mt="32px" gap={4}>
        <CloseModalButton
          closeModalLabel="Cancelar"
          close={() => history.push("/cadastros/areas-comum")}
        />

        <PrimaryButton
          isDisabled={isLoading || isLoadingAreaComum}
          isLoading={isLoading || isLoadingAreaComum}
          onClick={() => handleSubmit(_handleSave)()}
        >
          Salvar
        </PrimaryButton>
      </Flex>
    </>
  );
}

export default DadosCadastrais;
